<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> person_add_alt </v-icon>
      <span :class="ui.textHeadline"> Activate User </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
       Review new users and existing deactivated users. Validate authorisation levels and active the user.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <div v-if="enableSpinBtnSearch === false">
          <v-btn :disabled="false" :color="ui.btnColor"
            @click="searchSpecificUsers()" flat>
            <v-icon left> manage_accounts </v-icon>
              users
          </v-btn>
        </div>
        <div v-else>
          <BtnSpin :btnSpec="btnInfo1"/>
        </div>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import searchUsers from "@/data/search/mixins/searchUsers.js";
// import SearchUser from "@/data/search/components/SearchUser";

export default {
  mixins: [apptheme, dataSources, searchUsers],
  components: {
    BtnSpin
    // SearchUser
  },
  data() {
    return {
      enableSpinBtnSearch: false,
      search: {
        id: "", // id for search
        title: "", // title for search
        dbs: "", // data base source
        status: null,
        licence: ""
      },
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  methods: {
    searchSpecificUsers() {
      this.enableSpinBtnSearch = true;
      // Search Criteria for New User
      this.search.dbs = this.defineDataSourceFromTag("U1");
      this.search.status = false;

      if (this.search !== null) {
        this.searchUsers(this.search);
      }
    }
  }
};
</script>
